/* IMPORT */
import { Stack } from '../methods/debugger.js';
/* MAIN */
// This ensures that there's only one flushing of the queue happening at the same time
class Scheduler {
    constructor() {
        /* VARIABLES */
        this.waiting = [];
        this.counter = 0;
        this.locked = false;
        /* QUEING API */
        this.flush = () => {
            if (this.locked)
                return;
            if (this.counter)
                return;
            if (!this.waiting.length)
                return;
            try {
                this.locked = true;
                while (true) {
                    const queue = this.waiting;
                    if (!queue.length)
                        break;
                    this.waiting = [];
                    for (let i = 0, l = queue.length; i < l; i++) {
                        queue[i][0].update(queue[i][1]);
                    }
                }
            }
            finally {
                this.locked = false;
            }
        };
        this.wrap = (fn) => {
            this.counter += 1;
            fn();
            this.counter -= 1;
            this.flush();
        };
        /* SCHEDULING API */
        this.schedule = (observer, stack) => {
            this.waiting.push([observer, stack]);
        };
    }
}
/* EXPORT */
export default new Scheduler();
